import React, { Component } from "react";
import { connect } from "react-redux";
import { usrRole } from "../../utils/dataUtil";
import {
  req_list_cslc_public_activity,
  req_list_cslc_public_works,
  req_list_cslc_vote,
  req_add_csll_vote,
} from "../../api";
import { DEFAULT_IMAGE_URL } from "../../utils/contrains";
import { Button, Tag, Image, Collapse, BackTop, message, Modal } from "antd";
import "./jury-all-works-list.css";
import storageUtils from "../../utils/storageUtils";
import vote_img from "./assets/Vote.png";
const { Panel } = Collapse;

class VoterChoiceWorksList extends Component {
  state = {
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    enrollCode: "",
    checkCount: 0,
    startVoting: false /* VOTE_PROGRESS */,
    voteStatus: "CLOSE" /* CLOSE/VOTE_NOTBEGIN/VOTE_END */,
    voteActivity: "2022-1001-00001",
  };
  UNSAFE_componentWillMount() {
    this.api_check_activity();
  }

  componentDidMount() {
    this.api_check_voted();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_check_activity = async () => {
    const { voteActivity } = this.state;
    const result = await req_list_cslc_public_activity(voteActivity);

    //console.log(result)
    if (result.total > 0) {
      const { data } = result;
      const status = data[0].VoteStatus;
      //console.log(status);
      if (status === "VOTE_PROGRESS") {
        this.setState({ startVoting: true });
      }
      this.votestatuslabel =
        status === "VOTE_NOTBEGIN" ? (
          <Tag color="blue">尚未開始</Tag>
        ) : (
          <Tag color="gray">投票已結束</Tag>
        );
      this.setState({ voteStatus: status });
    }
  };

  api_check_voted = async () => {
    const { userCode } = this.props.user;
    // var userLevel = usrRole(role);
    // this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_list_cslc_vote(
      userCode,
      storageUtils.getUser().token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const count = result.total;
      this.setState({ checkCount: count }, () => {
        this.api_list_items();
      });
      //message.success("您已經投完票囉");
      //console.log("投票張數:", count);
    } else {
      this.api_list_items();
    }
  };

  api_list_items = async (prizeCode) => {
    const { role } = this.props.user;
    const { enrollCode } = this.state;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_list_cslc_public_works(enrollCode);
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { data } = result;
      const items = data;

      this.setState({ items });
      // console.log(items);
    } else {
      const items = [];
      this.setState({ items });
    }
  };

  api_save_items = (items) => {
    if (items.length < 4) {
      for (var idx = 0; idx < items.length; idx++) {
        req_add_csll_vote(items[idx], storageUtils.getUser().token);
        if (idx === items.length - 1) {
          message.success("謝謝您的參與，祝您中獎!!");
          this.handle_data_refresh();
        }
      }
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////

  handle_data_refresh = () => {
    this.api_check_voted();
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "VIEW":
        this.setState({ isPdfWorkModal: true, item });
        break;
      case "PRINT":
        this.setState({ isPrintWorkModal: true, item });
        break;
      case "download":
        break;
      default:
    }
  };

  handle_choice_item = (nowSelectedStatus, item) => {
    const { items } = this.state;
    const { Uid } = item;

    // console.log("Uid", Uid);
    const objIndex = items.findIndex((obj) => obj.Uid === Uid);
    const newSelectedStatus = nowSelectedStatus === "NO" ? "YES" : "NO";
    items[objIndex].VoterChoiceStatus = newSelectedStatus;
    // 改變狀態
    this.setState(items);
  };

  handle_data_selected = () => {
    const { items } = this.state;
    const { userCode, userName } = this.props.user;
    var count = 0;
    const selectedList = [];

    items.forEach(function (item) {
      if (item.VoterChoiceStatus === "YES") {
        count = count + 1;
        const obj = {
          VoterId: userCode,
          VoterName: userName,
          WorksId: item.WorksId,
          SelectedCode: item.EnrollCode,
        };
        selectedList.push(obj);
      }
    });

    if (count === 0) {
      message.error("您未選擇任一作品");
    } else if (count > 3) {
      message.error("您所選擇的數量超出規定");
    } else {
      Modal.confirm({
        title: `您確定投給這${count}項作品，送出後不得再改及重選`,
        onOk: () => {
          //console.log(selectedList);
          this.api_save_items(selectedList);
        },
      });
      // console.log(count);
      //console.log(selectedList);
    }
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading, items, checkCount, startVoting } = this.state;
    return (
      <>
        {startVoting ? (
          <>
            <div style={{ marginBottom: "4px", textAlign: "center" }}>
              <Button
                onClick={() => this.handle_data_selected()}
                type="primary"
                disabled={checkCount > 0 ? true : false}
              >
                <img src={vote_img} alt="" style={{ width: "16px" }} />
                <span style={{ marginLeft: "4px" }}>
                  {" "}
                  {checkCount > 0 ? "您已經投完選票" : "送出您的選票"}{" "}
                </span>
              </Button>
              <p style={{ marginTop: "4px" }}>
                <Tag color="red">
                  {checkCount > 0 ? (
                    ""
                  ) : (
                    <div style={{ fontSize: "1.4em", margin: "4px auto" }}>
                      <span>經初選後入選16件作品，一人可一次最多</span>
                      <br />
                      <span>選三件作品，送出選票後，就不得再變更</span>
                    </div>
                  )}
                </Tag>
              </p>
            </div>
            {loading ? (
              <div className="container">
                <div className="text-center">
                  <button
                    className="btn btn-light text-dark"
                    type="button"
                    disabled
                  >
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                    ></span>{" "}
                    查詢中 ......
                  </button>
                </div>
              </div>
            ) : (
              <>
                {items.length > 0 ? (
                  <>
                    {" "}
                    <div className="container">
                      <div className="row">
                        {items.map((item, index) => {
                          return (
                            <div
                              className="col-md-3"
                              key={index}
                              style={{ marginBottom: "10px" }}
                            >
                              <div className="thumbnail colstyle" key={index}>
                                <div
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    backgroundColor: "black",
                                    color: "white",
                                  }}
                                >
                                  <span style={{ color: "yellow" }}>
                                    編號：{item.WorksCode}
                                  </span>
                                  <span style={{ marginLeft: "4px" }}>
                                    作品名稱：{item.Title}
                                  </span>
                                </div>
                                <div className="caption">
                                  <Collapse accordion>
                                    <Panel
                                      header={
                                        <>
                                          創作理念
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              color: "gray",
                                            }}
                                          >
                                            (點此可看)
                                          </span>
                                        </>
                                      }
                                      key="2"
                                    >
                                      <p>{item.Description}</p>
                                    </Panel>
                                  </Collapse>
                                </div>
                                <div style={{ textAlign: "center" }}>
                                  <Image
                                    width={"250px"}
                                    height={"150px"}
                                    src={DEFAULT_IMAGE_URL + item.AttachedfileA}
                                  />
                                  <Image
                                    width={"250px"}
                                    height={"150px"}
                                    src={DEFAULT_IMAGE_URL + item.AttachedfileB}
                                  />
                                  <h6
                                    style={{
                                      color: "gray",
                                      marginTop: "2px",
                                      fontSize: "0.6em",
                                    }}
                                  >
                                    (點圖可放大)
                                  </h6>
                                </div>
                              </div>
                              <div
                                className="titleMame"
                                style={{ textAlign: "center" }}
                              >
                                {checkCount === 0 ? (
                                  <button
                                    type="button"
                                    className={
                                      item.VoterChoiceStatus === "YES"
                                        ? "btn btn-success btn-sm"
                                        : "btn btn-light btn-sm"
                                    }
                                    style={{ margin: "4px", width: "97%" }}
                                    onClick={() =>
                                      this.handle_choice_item(
                                        item.VoterChoiceStatus,
                                        item
                                      )
                                    }
                                  >
                                    {item.VoterChoiceStatus === "YES" ? (
                                      <i className="fa fa-check"></i>
                                    ) : (
                                      <i className="fa fa-thumbs-up"></i>
                                    )}

                                    <span style={{ marginLeft: "4px" }}>
                                      {item.VoterChoiceStatus === "YES"
                                        ? "給你一票"
                                        : "拜託選我"}
                                    </span>
                                  </button>
                                ) : (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      margin: "auto",
                                    }}
                                  >
                                    <span>
                                      已獲得{" "}
                                      <em style={{ color: "red" }}>
                                        {item.GetVoteTotal}
                                      </em>{" "}
                                      票
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <BackTop>
                      <div className="goTop">UP</div>
                    </BackTop>
                  </>
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <Tag color="gray" style={{ margin: "10px" }}>
                      尚無入選作品
                    </Tag>
                  </div>
                )}
              </>
            )}
          </>
        ) : (
          <div style={{ textAlign: "center", fontSize: "1.5em" }}>
            {this.votestatuslabel}
          </div>
        )}
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(VoterChoiceWorksList);
